import { render, staticRenderFns } from "./ProductHomepageMobile.vue?vue&type=template&id=00ae0988"
import script from "./ProductHomepageMobile.vue?vue&type=script&lang=js"
export * from "./ProductHomepageMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductHomepageMobile.vue?vue&type=style&index=0&id=00ae0988&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports